module.exports = __webpack_public_path__ + "img/pluto23.9b48e741.jpg";